// FooterContext.jsx
import { createContext, useContext, useState } from "react";

const FooterContext = createContext();

export const FooterProvider = ({ children }) => {
  const [footerContent, setFooterContent] = useState(null);
  const [title, setTitle] = useState("Dashboard")
  const [header, setHeader] = useState(null) 

  return (
    <FooterContext.Provider value={{ footerContent, setFooterContent, title, setTitle, header, setHeader }}>
      {children}
    </FooterContext.Provider>
  );
};

export const useFooter = () => useContext(FooterContext);